import { Button, CircularProgress } from "@mui/material";
import { alpha } from "@mui/material/styles";

/**
 * Full-width primary action button with a built-in inline loading spinner.
 * Replaces the repeated absolute-positioned CircularProgress blocks in the forms.
 */
function PrimaryButton({ loading = false, children, disabled, sx, ...rest }) {
  return (
    <Button
      fullWidth
      variant="contained"
      disabled={disabled || loading}
      sx={{
        py: 1,
        bgcolor: "secondary.main",
        color: "secondary.contrastText",
        fontWeight: 600,
        borderRadius: 2,
        fontSize: 15,
        textTransform: "none",
        position: "relative",
        boxShadow: (t) => `0 3px 5px 2px ${alpha(t.palette.secondary.main, 0.2)}`,
        "&:hover": {
          bgcolor: "secondary.dark",
          transform: "translateY(-1px)",
          boxShadow: (t) =>
            `0 4px 8px 2px ${alpha(t.palette.secondary.main, 0.3)}`,
        },
        "&.Mui-disabled": {
          bgcolor: "action.disabledBackground",
          color: "action.disabled",
        },
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        ...sx,
      }}
      {...rest}
    >
      {children}
      {loading && (
        <CircularProgress
          size={24}
          sx={{
            color: "inherit",
            position: "absolute",
            top: "50%",
            left: "50%",
            mt: "-12px",
            ml: "-12px",
          }}
        />
      )}
    </Button>
  );
}

export default PrimaryButton;
